<ng-container *ngIf="!isPatronAuthorized; else authorized">
  <div class="offers-box">
    <img class="icon" alt="offers" src="../../../../assets/offers-box.svg" />
    <button
      class="ins-buttons no-border button-primary flint w-100"
      data-automation-id="place-hold-btn"
      translate
      (click)="onGetIt($event)"
      [attr.aria-describedby]="'get-offers-button'"
    >
      Get it
    </button>
  </div>
</ng-container>

<ng-template #authorized>
  <ng-container *ngIf="loading; else loaded">
    <div class="offers-box offeravailable">
      <div class="spinner-container" role="status" aria-live="polite">
        <div class="data-box">
          <img class="icon" alt="offers" src="../../../../assets/offers-box.svg" />
        </div>
        <div
          class="spinner-border text-primary"
          data-automation-id="get-offers-spinner"
        >
          <span class="sr-only" translate>Loading...</span>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #loaded>
    <ng-container *ngIf="offer; else error">
      <div class="offers-box offeravailable">
        <div class="data-box">
          <img class="icon" alt="offers" src="../../../../assets/offers-box.svg" />
          <p class="text bold">Get a physical copy</p>
          <p class="text">
            Delivered in <span class="bold">{{ supplyTimeInDays }} days</span>
          </p>
          <p class="text">
            Keep for <span class="bold">{{ offer.loanPeriod }} days</span>
          </p>
        </div>

        <button
          class="ins-buttons no-border button-primary flint w-100"
          data-automation-id="place-hold-btn"
          translate
          (click)="onGetIt($event)"
          [attr.aria-describedby]="'get-offers-button'"
        >
          {{'request' | translate}}
        </button>

      </div>
    </ng-container>

    <ng-template #error>
      <div class="offers-box offeraunvailable">
        <div class="data-box">
          <img class="icon" alt="offers" src="../../../../assets/offers-box.svg" />
          <p class="text bold">Get a physical copy</p>
          <p class="text">This resource is currently unavailable</p>
        </div>
      </div>
    </ng-template>
  </ng-template>
</ng-template>
